import {TimePicker as SlTimePicker} from "surveylabJsAssets/datetime/timepicker";

/**
 * Override to use 5-minute steps for this time picker.
 */
const nextDiaryTimeElementID = 'timepicker-item-id-2100';

export class TimePicker extends SlTimePicker {
    protected options(): {} {
        return $.extend(true, super.options(), {
            stepping: 5,
        });
    }
}

// noinspection JSUnusedGlobalSymbols
export default () => {
    for (const $timepickerElement of $('.timepicker')) {
        if ($timepickerElement.id === nextDiaryTimeElementID) {
            new TimePicker($timepickerElement).createPicker();
        } else {
            new SlTimePicker($timepickerElement).createPicker();
        }
    }
}